import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
export function mapProps(mapper) {
    return function mapPropsHoc(Comp) {
        class MapPropsHoc extends Component {
            render() {
                const mappedProps = mapper(this.props);
                // TODO Not really sure why this is needed, but it is
                return _jsx(Comp, { ...mappedProps });
            }
        }
        MapPropsHoc.displayName = `mapProps(${Comp.displayName || Comp.name || 'Component'})`;
        return MapPropsHoc;
    };
}
